import React from 'react'
import { Tab } from '@headlessui/react'
import { cn } from 'common/utils'

const TabbedLayout = ({ panelClassName, tabs, children }) => {
  return (
    <Tab.Group>
      <Tab.List className="flex space-x-1 border-b-2 border-gray-300">
        {tabs.map(([label, count]) => (
          <Tab
            key={label}
            className={({ selected }) =>
              cn(
                'px-3 py-2 border-b-2 relative top-0.5 cursor-pointer',
                selected ? 'border-blue-500' : 'border-gray-300',
              )
            }
          >
            {label}

            <small className="mx-2">({count})</small>
          </Tab>
        ))}
      </Tab.List>
      <Tab.Panels>
        {React.Children.map(children, (child) => (
          <Tab.Panel className={panelClassName}>{child}</Tab.Panel>
        ))}
      </Tab.Panels>
    </Tab.Group>
  )
}

export default TabbedLayout
